import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { NamesOfParentRoutes } from "../../../../constants";
import { getUser } from "../../../Auth/store/selectors";

import { ERoles } from "containers/Auth/interfaces";
import { checkRoles } from "utils/ACL";

import "./index.scss";

const PlatformAdministrationContainer: React.FC = () => {
  const history = useHistory();
  const { communityCode } = useParams<{ communityCode: string }>();
  const currentUser = useSelector(getUser());
  const isSuperAdmin = checkRoles([ERoles.admin]);

  useEffect(() => {
    if (!currentUser || isSuperAdmin || !communityCode) {
      return;
    }
    history.replace(`/${communityCode}${NamesOfParentRoutes.EVENTS}`);
  }, [communityCode, currentUser, history, isSuperAdmin]);

  if (!currentUser || !isSuperAdmin) {
    return null;
  }

  return (
    <div className="platformAdministration">
      <div className="platformAdministration-welcomeCard">
        <div className="platformAdministration-welcomeCard-title">Platform Administration</div>
        <div className="platformAdministration-welcomeCard-description">
          Manage the Altar Live platform. Tools for super admins will appear here.
        </div>
      </div>
    </div>
  );
};

export default PlatformAdministrationContainer;
